import React from "react";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";

import useStrategicAccounts from "../../../hooks/use-strategic-accounts";
import { useMutation } from "../../../hooks/use-mutation";
import RebatesClient from "../../../RebatesClient";

import { CustomButton, CustomDialog, CustomSelect, FeaturedIcon, FormikTextField } from "../../../components";
import { CUSTOMER_TYPE_OPTIONS } from "../../../components/constants";

import css from "./modal-account.module.css";
import { useNavigate } from "react-router-dom";

const ModalAccount = ({
  open,
  onClose,
  account,
}) => {
  // const { strategicAccounts } = useStrategicAccounts();
  // const filteredAccount = strategicAccounts?.find(
  //   (acct) => acct?.id === account
  // );
  // console.log('filteredAccount', filteredAccount)
  // console.log('account', account)
   const navigate = useNavigate();

  
  const validationSchema = Yup.object({
    name: Yup.string().required("Account name is required"),
    address: Yup.string()/*.required("Address is required")*/,
    // rewards_code: Yup.string().required("Rewards ID is required"),
  });

  const { mutateAsync: submitRequest, isLoading, } = useMutation({
    mutationKey: "saveStrategicAccount",
    networkMode: "always",
    mutationFn: async (updatedData) =>  RebatesClient.saveStrategicAccount(updatedData,  account?.id),
    onError: (err)=> {console.log(err)},
    onSuccess: (resp) => {
      if(resp.response.status == 200){
        navigate(`/${account.account_type === 'STRATEGIC_ACCOUNT'? 'account' : 'sub-account'}/${encodeURIComponent(formik.values.name)}`, { replace: account?.id ? true : false })
        close()
      }
      else {
        alert(`Error saving account, ${resp.body.status}`)
      }

    }
  });
  

  const formik = useFormik({
    initialValues: {
      name: account?.name || "",
      address: account?.address || "",
      rewards_code: account?.rewards_code || "",
      customer_type: account?.customer_type || "",
    },

    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: submitRequest,
  });

  // const rebateLevels = [
  //   { id: 1, name: "1%" },
  //   { id: 2, name: "2%" },
  //   { id: 3, name: "3%" },
  //   { id: 4, name: "4%" },
  //   { id: 5, name: "5%" },
  //   { id: 6, name: "6%" },
  //   { id: 7, name: "7%" },
  //   { id: 8, name: "8%" },
  //   { id: 9, name: "9%" },
  //   { id: 10, name: "10%" },
  // ];

  const title = (
    <div className={css.modalTitle}>
      <FeaturedIcon icon={account ? "Edit" : "Plus"} />
      {account?.id ? "Edit" : "Add"} {account?.account_type === 'STRATEGIC_ACCOUNT' ? "Account" : "Sub Account"}
    </div>
  );

  function close(){
    formik.resetForm()
    onClose()
  }

  return (
    <CustomDialog open={open} onClose={close} width={640} title={title}>
      <FormikProvider value={formik}>
        <Form className={css.modalForm}>
          <FormikTextField
            label="Account Name*"
            labelShrink={true}
            name="name"
            type="text"
            value={formik.values.name}
          />

          <FormikTextField
            label="Account Address*"
            labelShrink={true}
            name="address"
            type="text"
            value={formik.values.address}
          />

          {account?.account_type === "STRATEGIC_ACCOUNT" && (
            <CustomSelect
              label="Account Classification"
              name="customer_type"
              value={formik.values.customer_type}
              onChange={formik.handleChange}
              options={CUSTOMER_TYPE_OPTIONS}
              displayEmpty
              halfWidth
            />
          )}
          
          {/* <CustomSelect
            label="Rebate Level*"
            name="rebateLevel"
            value={formik.values.rebateLevel}
            onChange={formik.handleChange}
            options={rebateLevels}
            halfWidth
          /> */}

          <FormikTextField
            label="Rewards ID"
            labelShrink={true}
            name="rewards_code"
            type="text"
            halfWidth
            value={formik.values.rewards_code}
          />

          <div className={css.actions}>
            <CustomButton
              label="Cancel"
              onClick={onClose}
              color="secondary"
            />

            <CustomButton
              label="Save"
              type="submit"
              color="primary"
              onSubmit={formik.handleSubmit}
            />
          </div>
        </Form>
      </FormikProvider>
    </CustomDialog>
  );
};

export default ModalAccount;
